import React, { FC, ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { styled } from '@creditas/stylitas'
import { Navigation } from '@creditas/icons'
import { useQueryParam, StringParam } from 'use-query-params'

const Container = styled.div`
  position: relative;

  select {
    appearance: none;
    background: #fff;
    border-radius: 16px;
    border: 1px solid #eee;
    color: #556666;
    cursor: pointer;
    font-family: Nunito Sans;
    font-size: 16px;
    outline: none;
    padding-left: 16px;
    padding-right: 32px;
    padding: 4px 32px 4px 16px;

    :hover {
      border-color: #3377bb;
    }
  }
`

const OrderButton = styled(Navigation.ChevronDown)`
  cursor: pointer;
  pointer-events: none;
  position: absolute;
  right: 4px;
  top: 0;
`

const Select: FC = () => {
  const { t } = useTranslation(['assignments'])
  const [orderBy, setOrderBy] = useQueryParam('orderBy', StringParam)
  const [, setOrientation] = useQueryParam('orientation', StringParam)
  const handleChange = (event: ChangeEvent) => {
    const select = event.target as HTMLSelectElement
    setOrderBy(select.value)
    setOrientation('asc')
  }

  return (
    <Container>
      <select onChange={handleChange} value={orderBy ?? 'fullName'}>
        <option value="" disabled>
          {t('card.order.description')}
        </option>
        <option value="closingProbability">
          {t('card.order.closing-probability')}
        </option>
        <option value="fullName">{t('card.order.name')}</option>
        <option value="scheduling">{t('card.order.next-contact')}</option>
        <option value="pipelineStatus">{t('card.order.pipeline')}</option>
      </select>
      <OrderButton />
    </Container>
  )
}

export { Select }
